function injectScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.async = true;
        script.src = src;
        script.addEventListener('load', resolve);
        script.addEventListener('error', () => reject(new Error('Error loading script.')));
        script.addEventListener('abort', () => reject(new Error('Script loading aborted.')));
        document.head.appendChild(script);
    });
}

export default injectScript;
